import { forIn } from "lodash";

import { AnonymizationLevel } from "./AnonymizationLevel";
import type { IrMap } from "./IrMap";

export class AnonymizationLevelFunctions {
    public static GetAnonymizationLevels(): AnonymizationLevel[] {
        const cgt: AnonymizationLevel[] = [];
        forIn(AnonymizationLevel, (key) => {
            if (typeof key === "number") {
                cgt.push(key as any as AnonymizationLevel);
            }
        });
        return cgt;
    }

    public static GetAnonymizationLevelDictionary(): IrMap<AnonymizationLevel, string, string> {
        const anonymizationLevelDictionary = AnonymizationLevelFunctions.GetAnonymizationLevels().map((cgt) => ({
            key: cgt,
            value: AnonymizationLevel[cgt],
            group: "",
        }));

        anonymizationLevelDictionary.forEach((al) => {
            switch (al.key) {
                case AnonymizationLevel.LowBlur:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.BlurEntireImage";
                    break;
                case AnonymizationLevel.HighBlur:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.BlurEntireImage";
                    break;
                case AnonymizationLevel.Anonymize:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithWhiteMasking";
                    break;
                case AnonymizationLevel.AnonymizeLowBlur:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithWhiteMasking";
                    break;
                case AnonymizationLevel.AnonymizeHighBlur:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithWhiteMasking";
                    break;
                case AnonymizationLevel.LowPixelization:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithPixelization";
                    break;
                case AnonymizationLevel.MediumPixelization:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithPixelization";
                    break;
                case AnonymizationLevel.HighPixelization:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationWithPixelization";
                    break;
                case AnonymizationLevel.Military:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AnonymizationMotionAndEnvironment";
                    break;
                case AnonymizationLevel.AdvancedAdaptivePixelization:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.AdvancedMotionAndStaticAnonymization";
                    break;
                case AnonymizationLevel.HumanOnlyAnonymization:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.HumanOnlyAnonymization";
                    break;
                case AnonymizationLevel.HumanOnlyMediumPixelizationGray:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.HumanOnlyAnonymization";
                    break;
                case AnonymizationLevel.HumanOnlyHighPixelizationGray:
                    al.group = "Gui.Manage.AnonymizationLevelGroup.HumanOnlyAnonymization";
                    break;
                default:
                    break;
            }
        });

        return anonymizationLevelDictionary;
    }
}
